import { useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ProfileForm = () => {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user.name || "", phone: user.phone || "", address: user.address || "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.patch("/customers/me", form);
      setUser(data);
      toast.success("Datos guardados correctamente");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-5 max-w-2xl" data-testid="customer-profile-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label htmlFor="p-name">Nombre completo</Label>
          <Input id="p-name" data-testid="customer-profile-name-input" required minLength={2}
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="p-email">Correo electrónico</Label>
          <Input id="p-email" data-testid="customer-profile-email" value={user.email} disabled className="bg-slate-50" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="p-phone">Teléfono</Label>
          <Input id="p-phone" data-testid="customer-profile-phone-input" placeholder="6XX XXX XXX"
            value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="p-address">Dirección habitual de recogida</Label>
        <Input id="p-address" data-testid="customer-profile-address-input" placeholder="Calle, número, piso, ciudad"
          value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
        <p className="text-xs text-slate-500">La usaremos para rellenar tus reservas y calcular la gasolina del desplazamiento.</p>
      </div>
      <Button type="submit" disabled={saving} data-testid="customer-profile-save-btn" className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-7">
        <Save className="h-4 w-4 mr-2" /> {saving ? "Guardando..." : "Guardar cambios"}
      </Button>
    </form>
  );
};
